import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetKnowledgebaseArticleDetails Input Action
 */
export class GetKnowledgebaseArticleDetailsInput implements Msdyn365.IActionInput {
    public kbArticleId: string;
    constructor(kbArticleId: string) {
        this.kbArticleId = kbArticleId;
    }

    public getCacheKey = () => `GetKnowledgebaseArticlesDetail-${this.kbArticleId}`;
    public getCacheObjectType = () => 'GetKnowledgebaseArticlesDetail';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetKnowledgebaseArticleDetailsData {
    '@odata.context': string;
    Content: string;
    CreationDate: string;
    Description: string;
    Keywords: string;
    KnowledgeArticleId: string;
    KnowledgeArticleViews: string;
    PreviewContent: string;
    RatingCount: string;
    ReatingDate: string;
    StatusCode: string;
    Title: string;
    ArticlePublicNumber: string;
    KnowledgeArticleviewsDate: string;
    RatingDate: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetKnowledgebaseArticleDetailsInput('');
};

async function action(
    input: GetKnowledgebaseArticleDetailsInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetKnowledgebaseArticleDetailsData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const response = await Msdyn365.sendRequest<IGetKnowledgebaseArticleDetailsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetKnowledgeArticleDetail(language='${ctx.requestContext.locale}', articleId='${input.kbArticleId}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetKnowledgebaseArticleDetailsData>>action,
    id: 'GetKnowledgebaseArticleDetails',
    input: createInput
});
